import { variablePattern } from './constants';
/**
 *
 * Get variables for specific mapping
 * @param {string} mapping - Url with mapped variables for example 'my-shoes/{{product-name}}'
 * @return {Array} variables - Repeated string with the variables from the mapping for example '["product-name"]'
 * @example <caption>Usage of the method</caption>
 * // returns ["product-name"]
 * getMappingVariables('/my-shoes/{{product-name}}');
 *
 **/
export var getMappingVariables = function (mapping) {
    if (!mapping) {
        return [];
    }
    return Array.from(mapping.matchAll(new RegExp(variablePattern, 'g')), function (matches) { return matches[1]; });
};
//# sourceMappingURL=get-mapping-variables.js.map